"use client";

import React from "react";
import {
	HmcButton,
	HmcIcon,
	HmcTooltip,
} from "@adi-ctx/harmonic-core-components-react";
import { t } from "@/utils";
import "./pagination-controls.scss";

type PaginationControlsProps = {
	readonly numOfDrivers: number;
	readonly itemsPerPage: number;
	readonly currentPage: number;
	readonly firstPage: () => void;
	readonly lastPage: () => void;
	readonly nextPage: () => void;
	readonly prevPage: () => void;
};

const PaginationControls: React.FC<PaginationControlsProps> = ({
	numOfDrivers,
	itemsPerPage,
	currentPage,
	firstPage,
	lastPage,
	nextPage,
	prevPage,
}) => {
	const totalPages = Math.ceil(numOfDrivers / itemsPerPage);

	return (
		<div className="container">
			<div className="pagination-controls">
				<HmcButton
					id="first-button"
					kind="ghost"
					onClick={firstPage}
					isDisabled={currentPage <= 1}
				>
					<HmcIcon slot="icon-left" name="skip-left-m" />
				</HmcButton>
				<HmcTooltip triggerId="prev-button" placement="top">
					First Page
				</HmcTooltip>
			</div>
			<div className="pagination-controls">
				<HmcButton
					id="prev-button"
					kind="ghost"
					onClick={prevPage}
					isDisabled={currentPage <= 1}
				>
					<HmcIcon slot="icon-left" name="arrow-left-m" />
				</HmcButton>
				<HmcTooltip triggerId="prev-button" placement="top">
					Previous Page
				</HmcTooltip>
			</div>
			<div className="number-bar">
				<span>
					Page {currentPage} of {Math.ceil(numOfDrivers / itemsPerPage)}
				</span>
			</div>
			<div className="pagination-controls">
				<HmcButton
					id="next-button"
					kind="ghost"
					onClick={nextPage}
					isDisabled={currentPage === totalPages}
				>
					<HmcIcon slot="icon-right" name="arrow-right-m" />
				</HmcButton>
				<HmcTooltip triggerId="next-button" placement="top">
					Next Page
				</HmcTooltip>
			</div>
			<div className="pagination-controls">
				<HmcButton
					id="last-button"
					kind="ghost"
					onClick={lastPage}
					isDisabled={currentPage === totalPages}
				>
					<HmcIcon slot="icon-right" name="skip-right-m" />
				</HmcButton>
				<HmcTooltip triggerId="next-button" placement="top">
					Last Page
				</HmcTooltip>
			</div>
		</div>
	);
};

export default PaginationControls;
